import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-collapsible-group',
    templateUrl: './collapsible-group.component.html',
    styleUrls: ['./collapsible-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class CollapsibleGroupComponent {
  @Input() collapsed = true;
  @Output() collapsedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  toggle(): void {
    this.collapsed = !this.collapsed;
    this.collapsedChange.emit(this.collapsed);
  }
}
